import React, { memo } from "react";
import { Button } from "../../Button";
import { EmptyState, EmptyStateIconBackground, EmptyStateIllustrationIcon } from "../../EmptyState";
import { useGetMaintenancePeriod } from "../utils";

import styles from "./styles.module.scss";

export const MaintenanceBlock = memo(() => {
  return (
    <EmptyState
      size={"sm"}
      header={"Scheduled Maintenance Notice"}
      icon={
        <>
          <EmptyStateIconBackground type="circle">
            <EmptyStateIllustrationIcon iconType="CloudGrayMd" />
          </EmptyStateIconBackground>
        </>
      }>
      <div className={styles.text}>
        <b>Please be advised:</b>
        <br />
        Our system will undergo <b>scheduled maintenance</b> on:
        <br />
        <br />
        <b>🗓️ {useGetMaintenancePeriod()}</b>
        <br />
        <br />
        During this time, <b>the portal will be temporarily unavailable.</b>
        This maintenance is essential to ensure continued performance and security improvements.
        <br />
        <br />
        We apologize for any inconvenience and appreciate your patience.
        If you have any questions, please contact us at
        <Button
          className={styles.mail}
          component={"a"}
          href="mailTo:support@tecorien.com"
          buttonType="linkColor"
          buttonSize="lg"
        >
          support@tecorien.com.
        </Button>
      </div>
    </EmptyState>
  );
});